"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _KYCSumSubSdkContainer = _interopRequireDefault(require("./KYCSumSubSdkContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var KYCSumSubModal = function KYCSumSubModal(_ref) {
  var isOpen = _ref.isOpen,
    onCancel = _ref.onCancel;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    customClass: "modal-sumsub",
    title: "SumSub Validation",
    isOpen: !!isOpen,
    onCancel: onCancel,
    close: onCancel
  }, /*#__PURE__*/_react["default"].createElement(_KYCSumSubSdkContainer["default"], null));
};
var _default = exports["default"] = KYCSumSubModal;